import Vue from 'vue';
import Component from 'vue-class-component';

export interface TableColumn {
  field: string;
  fieldType?: FieldType;
  title?: string;
  formatter?: (value: any, row: any, column: TableColumn) => string;
  component?: Vue;
  sortable?: boolean;
  sortDirection?: SortDirection;
  editable?: boolean;
  editing?: boolean;
  width?: string;
  fixed?: FixedColumn;
  group?: boolean;
  total?: boolean;
  headerClass?: string;
  cellStyle?: (value: any, row: any, column: TableColumn) => string;
  hidden?: boolean;
  attributes?: any;
  headerAttributes?: any;
  cellActions?: Array<TableColumnAction>;
  editorOptions?: TableColumnEditOptions;
  data?: any;
  allowNull?: boolean | ((value: any, row: any, column: TableColumn) => boolean);
}

export enum SortDirection {
  Ascending,
  Descending
}

export enum FieldType {
  Time,
  Date,
  DateTime,
  Dollar,
  Number,
  Decimal,
  String
}

export enum FixedColumn {
  left = 'left',
  right = 'right'
}

export interface TableColumnEditOptions {
  beforeEdit?: (value: any, row: any, column: TableColumn) => any;  
  edit?: (value: any, row: any, column: TableColumn) => any;  
}

export interface TableColumnEditNumberOptions extends TableColumnEditOptions {

}

export interface TableColumnAction {
  icon: string;
  click?: (value: any, row: any, column: TableColumn) => void;  
}


// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/table/table-column.ts